/**
 * @ngdoc directive
 * @name olyOnBlur
 *
 * This component captures blur events from all children of an element and evaluates the given
 * expression whenever focus moves out of the element where is was put.
 *
 * This differs from ng-blur because ng-blur doesn't capture blur events from children.
 */
const onBlurDirectiveDefinition = () => ({
    restrict: 'A',
    link(scope, element, attrs) {
        function closeIfFocusOutside($event) {
            setTimeout(() => {
                /* RelatedTarget & document.activeElement works in Chrome
                   ExplicitOriginalTarget works in Firefox
                   In Safari, RelatedTarget and document.activeElement returns an incorrect value (usually the body) if a button/input is clicked
                */
                const focusedElement = $event.relatedTarget || $event.explicitOriginalTarget || document.activeElement;

                if (focusedElement !== null && !element.is(focusedElement) && element.has(focusedElement).length === 0) {
                    scope.$apply(() => scope.$evalAsync(attrs.olyOnBlur));
                }
            });
        }

        // capture allows us to get blur events from children
        element[0].addEventListener('blur', $event => closeIfFocusOutside($event), true);
    },
});

module.exports = {
    onBlurDirectiveDefinition,
};



// WEBPACK FOOTER //
// ./src/olycommon/onblur/on-blur.directive.js